import { i18n } from '@/locales';

const isValidVatNumber = {
  message: () => i18n.t('Please enter a valid VAT number'),
  validate(vatNumber) {
    return /^[a-z0-9-. ]+$/i.test(vatNumber) && !/^[a-z]+$/i.test(vatNumber);
  }
};

export default isValidVatNumber;